export default __webpack_public_path__ + "static/media/upload.b969462c.png";